module.exports = __webpack_public_path__ + "img/banner-text.1b95338d.png";